import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c6f7ee4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c6f7ee4&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=0c6f7ee4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f7ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6f7ee4')) {
      api.createRecord('0c6f7ee4', component.options)
    } else {
      api.reload('0c6f7ee4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c6f7ee4&scoped=true", function () {
      api.rerender('0c6f7ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoticeIcon/index.vue"
export default component.exports